"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _polished = require("polished");

var DEFAULT_COLOURS = {
  dark: ["rgba(0, 0, 0, 1)", "rgba(0, 0, 0, 0.87)", "rgba(0, 0, 0, 0.65)", "rgba(0, 0, 0, 0.38)", "rgba(0, 0, 0, 0.16)", "rgba(0, 0, 0, 0.12)", "rgba(0, 0, 0, 0.08)", "rgba(0, 0, 0, 0.04)"],
  error: ["rgba(191, 70, 48, 1)", "rgba(191, 70, 48, 0.6)", "rgba(191, 70, 48, 0.38)", "rgba(191, 70, 48, 0.16)", "rgba(191, 70, 48, 0.12)"],
  light: ["rgba(255, 255, 255, 1)", "rgba(255, 255, 255, 0.6)", "rgba(255, 255, 255, 0.38)", "rgba(255, 255, 255, 0.32)", "rgba(255, 255, 255, 0.24)", "rgba(255, 255, 255, 0.16)", "rgba(255, 255, 255, 0.12)", "rgba(255, 255, 255, 0.08)"]
};
var opacities = [1, 0.6, 0.38, 0.16, 0.12];

var generateContrastingTint = function generateContrastingTint(colour) {
  var potentialTint = (0, _polished.darken)(0.1, colour);

  var _meetsContrastGuideli = (0, _polished.meetsContrastGuidelines)(potentialTint, DEFAULT_COLOURS.light[0]),
      meetsAccessibilityGuidelines = _meetsContrastGuideli.AAA;

  return meetsAccessibilityGuidelines ? potentialTint : generateContrastingTint(potentialTint);
};

var createColourPalette = function createColourPalette(baseColour) {
  var tint = generateContrastingTint(baseColour);
  var primary = opacities.map(function (opacity) {
    return (0, _polished.rgba)(tint, opacity);
  });
  var secondary = opacities.map(function (opacity) {
    return (0, _polished.rgba)(baseColour, opacity);
  });
  return (0, _extends2["default"])({}, DEFAULT_COLOURS, {
    primary: primary,
    secondary: secondary
  });
};

var _default = createColourPalette;
exports["default"] = _default;